import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
    calculateDownPayment,
    getDealInfo,
    getSelectedPricingDetails,
    getAppliedDealerSettings,
} from '@atc/wallet-payment-fns';

import { fallbackInterestRates as nationalRates } from 'axl-config';

import { paymentsDuck, resultsDuck } from '@syndicated-wallet/ducks';

export default ({ dealToSubmit, listingId, config }) => {
    const {
        paymentServices: { dealerSettings = {} } = {},
        pricingDetail = {},
        type: vehicleCondition = 'used',
    } = useSelector(resultsDuck.selectors.getActiveInventory)[0] || {};

    let payments = useSelector(paymentsDuck.selectors.getState) || {};
    const { interactions: walletInteractions } = payments;

    const { cashDealPrice } = config;

    useEffect(() => {
        const { paymentDetails, selectedPricingDetails, price } = getSelectedPricingDetails(
            payments,
            listingId,
            pricingDetail,
            cashDealPrice
        );
        const {
            downPaymentPercent,
            downPayment: downPaymentValue,
            ...restSettings
        } = getAppliedDealerSettings({ dealerSettings, walletInteractions, price, payments, nationalRates });

        // eslint-disable-next-line react-hooks/exhaustive-deps
        payments = {
            ...payments,
            ...restSettings,
        };

        payments.downPayment = calculateDownPayment(price, { downPayment: downPaymentValue, downPaymentPercent });

        const { deal = {} } = getDealInfo(selectedPricingDetails, paymentDetails, vehicleCondition, payments, true);

        dealToSubmit.current = deal;
    }, [payments, pricingDetail, vehicleCondition]);

    return null;
};
